jQuery(document).ready(function($) {
    'use strict';

    var flyout = $('#flyout');

    var flyout_filter_template = wp.template('flyout-filter');
    var flyout_event_template = wp.template('flyout-event');
    var flyout_group_template = wp.template('flyout-group');

    $(document).on('click', '.flyout-trigger', function() {
        history.pushState({}, '');
        flyout.addClass('open');
        openDrawerBackground();

        if ($(this).hasClass('flyout-event')) {
            flyout.html(flyout_event_template({
                event_id: $(this).data('flyout'),
                event_title: $(this).data('event_title'),
                event_type: $(this).data('event_type'),
                event_slug: $(this).data('event_slug'),
                event_date: $(this).data('event_date'),
                event_start_date: $(this).data('event_start_date'),
                event_image: $(this).data('event_image'),
                event_document: $(this).data('event_document'),
                event_content: $(this).data('event_content'),
                event_address: $(this).data('event_address'),
                event_link: $(this).data('event_link'),
                event_location: $(this).data('event_location'),
                event_organizer: $(this).data('event_organizer'),
                event_organizer_phone: $(this).data('event_organizer_phone'),
                event_organizer_email: $(this).data('event_organizer_email'),
            }));
            const shareData = {
                title: $(this).data('event_title'),
                text: $(this).data('event_type'),
                url: 'https://www.aa.se/medlemmar/kalender#' +
                    $(this).data('event_slug') +
                    '-' +
                    $(this).data('event_date') +
                    '-event-' +
                    $(this).data('flyout'),
            };
            const btn = document.querySelector('.share-button');
            btn.addEventListener('click', function() {
                navigator.share(shareData);
            });
        } else if ($(this).hasClass('flyout-group')) {
            flyout.html(flyout_group_template({
                group_data: $(this).data('group_data'),
                group_meetings: $(this).data('group_meetings'),
            }));
        } else if ($(this).hasClass('flyout-filter')) {
            flyout.html(flyout_filter_template({}));
        }
    });

    $(document).on('click', '#drawer-background, .flyout-close', function(e) {
        if (e.target !== this) {
            return;
        }
        flyout.removeClass('open');
        $('#flyout-meeting-type').removeClass('open');
        $('#flyout-menu').removeClass('open');
        $('.submenu').removeClass('visible');
        $('#search-filters').removeClass('open');
        $('.meeting-type-back').hide();
        $('.meeting-type-content').slideUp();
        closeDrawerBackground();
    });

    $(document).on('click', '.filter-open', function() {
        history.pushState({}, '');
        $('#search-filters').addClass('open');
        openDrawerBackground();
    });
    $(document).on('click', '.menu-open', function() {
        history.pushState({}, '');
        $('#flyout-menu').addClass('open');
        openDrawerBackground();
    });
    $(document).on('click', '.submenu-open', function() {
        $(this).next().addClass('visible');
    });
    $(document).on('click', '.submenu-back', function() {
        $('.submenu').removeClass('visible');
    });
    $(document).on('click', '.submenu-close', function() {
        flyout.removeClass('open');
        $('#flyout-menu').removeClass('open');
        closeDrawerBackground();
    });

    var hash = window.location.hash.substring(1, window.location.hash.length);
    var flyout_id = /[^-]*$/.exec(hash)[0];
    if (window.location.hash) {
        setTimeout(function() {
            if ($('.flyout-event').length > 0) {
                $('.flyout-event[data-flyout*=' + flyout_id + ']')
                    .trigger('click');
            }
            if ($('.flyout-group').length > 0) {
                $('.flyout-group[data-flyout*=' + flyout_id + ']')
                    .trigger('click');
            }
        }, 300);
    }

    window.onpopstate = function() {
        flyout.removeClass('open');
        $('#flyout-meeting-type').removeClass('open');
        $('#flyout-menu').removeClass('open');
        $('.submenu').removeClass('visible');
        $('#search-filters').removeClass('open');
        $('.meeting-type-back').hide();
        $('.meeting-type-content').slideUp();
        closeDrawerBackground();
    };

});
